import classes from "./ArticleInfo.module.css";
import {ArticleDetails} from "../../../../../../interfaces/response/ArticleDetails";
import {Box, Flex, Stack} from "@mantine/core";
import FormTextInput from "../../textInput/FormTextInput";
import {useArticleDetailsForm, useArticleDetailsFormContext} from "../../ModalArticle";
import {articleAttributes, colors} from "../../../../../../utils/ArticleUtils";
import {useMediaQuery} from "@mantine/hooks";

interface ArticleInfoProps {
    article: ArticleDetails
}

/**
 * Contains the section related to the editable information of the article
 * It dynamically generates form inputs based on the category of the product
 * @param article
 * @constructor
 */
export default function Articleinfo({article}: ArticleInfoProps) {

    const isMobile = useMediaQuery("(max-width: 48em)"); // Check if the screen is mobile
    const HalfTextInputWidth = isMobile ? "100%" : "48.5%";
    const thirdTextInputWidth = isMobile ? "48%" : "32.5%";

    return (
        <Box className={classes.root}>
            <Stack gap={'sm'}>
                <Flex gap={'sm'}>
                    {/*General Form Inputs*/}
                    <FormTextInput
                        //classes={{input: classes.input}}
                        width={thirdTextInputWidth}
                        label={"Marca"}
                        formInfo={{formLabel: "Marca", formContext: useArticleDetailsFormContext}}
                        options={articleAttributes["Marca"]?.options ?? []}
                    />
                    <FormTextInput
                        width={thirdTextInputWidth}
                        label={"Classe Energetica"}
                        formInfo={{formLabel: "Classe Energetica", formContext: useArticleDetailsFormContext}}
                        options={articleAttributes["Classe Energetica"]?.options ?? []}/>
                    <FormTextInput
                        width={thirdTextInputWidth}
                        label={"Scala Energetica"}
                        formInfo={{formLabel: "Scala Energetica", formContext: useArticleDetailsFormContext}}
                        options={articleAttributes["Scala Energetica"]?.options ?? []}/>
                </Flex>
                <Flex gap={'sm'} wrap={"wrap"}>
                    <FormTextInput
                        width={thirdTextInputWidth}
                        label={"Altezza (cm)"}
                        formInfo={{formLabel: "Altezza", formContext: useArticleDetailsFormContext}}
                    />
                    <FormTextInput
                        width={thirdTextInputWidth}
                        label={"Larghezza (cm)"}
                        formInfo={{formLabel: "Larghezza", formContext: useArticleDetailsFormContext}}

                    />
                    <FormTextInput
                        width={thirdTextInputWidth}
                        label={"Profondità (cm)"}
                        formInfo={{formLabel: "Profondità", formContext: useArticleDetailsFormContext}}
                    />
                </Flex>
                <Flex gap={'sm'}>
                    <FormTextInput
                        width={HalfTextInputWidth}
                        label={"Colore"}
                        options={colors}
                        formInfo={{formLabel: "Colore", formContext: useArticleDetailsFormContext}}
                    />
                    <FormTextInput
                        width={HalfTextInputWidth}
                        label={"Rumorosità"}
                        formInfo={{formLabel: "Rumorosità", formContext: useArticleDetailsFormContext}}
                    />
                </Flex>
                {/*Specific Form Inputs*/}
                <Flex gap={'sm'} wrap={"wrap"}>
                    {Object.entries(articleAttributes)
                        .filter(([_, details]) => {
                            return (details !== undefined
                                && details.categories !== undefined
                                && (details.categories.includes(article.headerArticleDetails.category)))
                        }).map(([attribute, details], index) => {
                            const label = ('label' in details && details['label']) ? details['label'] : attribute;
                            const formLabel = ('formLabel' in details && details['formLabel']) ? details['formLabel'] : attribute;
                            const options = details['options'] ?? undefined;
                            return (
                                <FormTextInput
                                    key={index}
                                    width={HalfTextInputWidth}
                                    label={label}
                                    options={options}
                                    formInfo={{formLabel: formLabel, formContext: useArticleDetailsFormContext}}/>
                            )
                        })}
                </Flex>
                <Flex gap={'sm'}>
                    <FormTextInput
                        width={thirdTextInputWidth}
                        label={"PDF Classe Energetica"}
                        formInfo={{formLabel: "PDF Classe Energetica", formContext: useArticleDetailsFormContext}}
                    />
                    <FormTextInput
                        width={thirdTextInputWidth}
                        label={"PDF Scheda Prodotto"}
                        formInfo={{formLabel: "PDF Scheda Prodotto", formContext: useArticleDetailsFormContext}}
                    />
                </Flex>
            </Stack>
        </Box>
    )
}